import { CompletePage } from "apps/batchOnboarding/complete/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(CompletePage, "BulkCompletePage");
